// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-response-container {
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem;
}

.survey-header {
  text-align: center;
  margin-bottom: 2rem;
}

.survey-header h1 {
  color: #333;
  margin-bottom: 0.5rem;
}

.dark .survey-header h1 {
  color: #f3f4f6;
}

.survey-header p {
  color: #666;
  margin-bottom: 1.5rem;
}

.dark .survey-header p {
  color: #9ca3af;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-fill {
  height: 100%;
  background: #007bff;
  transition: width 0.3s ease;
}

.progress-text {
  color: #666;
  font-size: 0.9rem;
}

.questions-container {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
}

.response-question {
  margin-bottom: 2rem;
}

.response-question:last-child {
  margin-bottom: 0;
}

.question-label {
  display: block;
  font-weight: 500;
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.required {
  color: #dc3545;
  margin-left: 0.25rem;
}

.options-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.radio-option,
.checkbox-option {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.radio-option:hover,
.checkbox-option:hover {
  background: #e9ecef;
}

.radio-option input,
.checkbox-option input {
  margin-right: 0.75rem;
}

.text-answer {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  resize: vertical;
}

.rating-group {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.rating-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;
}

.rating-label {
  margin-top: 0.5rem;
  font-size: 1.2rem;
  font-weight: 500;
}

.rating-option input[type="radio"] {
  width: 20px;
  height: 20px;
}

.dropdown-answer {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.navigation-buttons {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.navigation-buttons button {
  flex: 1 1;
  max-width: 200px;
}

.btn-success {
  background: #28a745;
  color: white;
}

.btn-success:hover {
  background: #218838;
}

.btn-success:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-success:disabled:hover {
  background: #9ca3af;
}

.success-message {
  text-align: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.success-message h2 {
  color: #28a745;
  margin-bottom: 1rem;
}

.success-message p {
  color: #666;
  margin-bottom: 2rem;
}

/* Dark mode styles */
.dark .survey-response-container {
  background: transparent;
}

.dark .questions-container {
  background: #1f2937;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.dark .progress-bar {
  background: #374151;
}

.dark .progress-text {
  color: #9ca3af;
}

.dark .question-label {
  color: #f3f4f6;
}

.dark .radio-option,
.dark .checkbox-option {
  background: #111827;
  color: #e5e7eb;
}

.dark .radio-option:hover,
.dark .checkbox-option:hover {
  background: #374151;
}

.dark .text-answer {
  background: #111827;
  border: 1px solid #4b5563;
  color: #f3f4f6;
}

.dark .text-answer:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.dark .rating-label {
  color: #e5e7eb;
}

.dark .dropdown-answer {
  background: #111827;
  border: 1px solid #4b5563;
  color: #f3f4f6;
}

.dark .dropdown-answer option {
  background: #1f2937;
  color: #f3f4f6;
}

.dark .success-message {
  background: #1f2937;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.dark .success-message h2 {
  color: #10b981;
}

.dark .success-message p {
  color: #9ca3af;
}`, "",{"version":3,"sources":["webpack://./src/components/SurveyResponse.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".survey-response-container {\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.survey-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.survey-header h1 {\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.dark .survey-header h1 {\n  color: #f3f4f6;\n}\n\n.survey-header p {\n  color: #666;\n  margin-bottom: 1.5rem;\n}\n\n.dark .survey-header p {\n  color: #9ca3af;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n}\n\n.progress-fill {\n  height: 100%;\n  background: #007bff;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.questions-container {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-bottom: 2rem;\n}\n\n.response-question {\n  margin-bottom: 2rem;\n}\n\n.response-question:last-child {\n  margin-bottom: 0;\n}\n\n.question-label {\n  display: block;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n}\n\n.required {\n  color: #dc3545;\n  margin-left: 0.25rem;\n}\n\n.options-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.radio-option,\n.checkbox-option {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem;\n  background: #f8f9fa;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.radio-option:hover,\n.checkbox-option:hover {\n  background: #e9ecef;\n}\n\n.radio-option input,\n.checkbox-option input {\n  margin-right: 0.75rem;\n}\n\n.text-answer {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  resize: vertical;\n}\n\n.rating-group {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n}\n\n.rating-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0.5rem;\n  cursor: pointer;\n}\n\n.rating-label {\n  margin-top: 0.5rem;\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n\n.rating-option input[type=\"radio\"] {\n  width: 20px;\n  height: 20px;\n}\n\n.dropdown-answer {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.navigation-buttons {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.navigation-buttons button {\n  flex: 1;\n  max-width: 200px;\n}\n\n.btn-success {\n  background: #28a745;\n  color: white;\n}\n\n.btn-success:hover {\n  background: #218838;\n}\n\n.btn-success:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.btn-success:disabled:hover {\n  background: #9ca3af;\n}\n\n.success-message {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.success-message h2 {\n  color: #28a745;\n  margin-bottom: 1rem;\n}\n\n.success-message p {\n  color: #666;\n  margin-bottom: 2rem;\n}\n\n/* Dark mode styles */\n.dark .survey-response-container {\n  background: transparent;\n}\n\n.dark .questions-container {\n  background: #1f2937;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.3);\n}\n\n.dark .progress-bar {\n  background: #374151;\n}\n\n.dark .progress-text {\n  color: #9ca3af;\n}\n\n.dark .question-label {\n  color: #f3f4f6;\n}\n\n.dark .radio-option,\n.dark .checkbox-option {\n  background: #111827;\n  color: #e5e7eb;\n}\n\n.dark .radio-option:hover,\n.dark .checkbox-option:hover {\n  background: #374151;\n}\n\n.dark .text-answer {\n  background: #111827;\n  border: 1px solid #4b5563;\n  color: #f3f4f6;\n}\n\n.dark .text-answer:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n.dark .rating-label {\n  color: #e5e7eb;\n}\n\n.dark .dropdown-answer {\n  background: #111827;\n  border: 1px solid #4b5563;\n  color: #f3f4f6;\n}\n\n.dark .dropdown-answer option {\n  background: #1f2937;\n  color: #f3f4f6;\n}\n\n.dark .success-message {\n  background: #1f2937;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.3);\n}\n\n.dark .success-message h2 {\n  color: #10b981;\n}\n\n.dark .success-message p {\n  color: #9ca3af;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
